/**
 * Opens the browser print dialog for a PDF (iframe avoids printing the whole app chrome).
 * @param {string} blobUrl — object URL or remote URL; only revoked when revokeUrl is true
 * @param {{ revokeUrl?: boolean }} options
 */
export function printPdfFromUrl(blobUrl, { revokeUrl = false } = {}) {
  return new Promise((resolve, reject) => {
    const iframe = document.createElement('iframe');
    iframe.setAttribute(
      'style',
      'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;',
    );
    iframe.src = blobUrl;

    const cleanup = () => {
      if (revokeUrl) {
        URL.revokeObjectURL(blobUrl);
      }
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    };

    iframe.onload = () => {
      try {
        const win = iframe.contentWindow;
        if (!win) {
          throw new Error('Could not open PDF for printing.');
        }
        win.focus();
        win.print();
        resolve();
      } catch (err) {
        cleanup();
        reject(err);
      }
    };

    iframe.onerror = () => {
      cleanup();
      reject(new Error('Could not load PDF for printing.'));
    };

    document.body.appendChild(iframe);
    // Keep iframe until tab unloads; revoking the blob URL too early breaks print in some browsers.
    if (revokeUrl) {
      setTimeout(cleanup, 120_000);
    }
  });
}

/**
 * @param {Blob | Uint8Array} data
 */
export async function printPdfFromBlob(data) {
  const blob =
    data instanceof Blob ? data : new Blob([data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  await printPdfFromUrl(url, { revokeUrl: true });
}
